import { PopoverPlacement } from "@idui/react-popover";
import {
  AssignmentInd,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "../../../tooltips";

interface IButtonOpenPassenger {
  watchedId: number | undefined;
  onClick: () => void;
  readonlyMode?: boolean;
}

export const ButtonOpenPassenger: FC<IButtonOpenPassenger> = ({
  watchedId,
  readonlyMode,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <FramerTooltip
      content={
        !watchedId
          ? t("ride.PLEASE_CHOOSE_PASSENGER_FIRST")
          : t("general.MANAGE_ENTITY", {
              entity: startCase(t("passenger.single")),
            })
      }
      placement={PopoverPlacement.top}
    >
      {/* Prevent "A disabled element does not fire events." MUI error*/}
      <span>
        <IconButton disabled={!watchedId} onClick={onClick} color="primary">
          {!readonlyMode && <AssignmentInd />}
          {!!readonlyMode && <VisibilityIcon />}
        </IconButton>
      </span>
    </FramerTooltip>
  );
};
